import { API_REQUEST } from ".";
import {
  changePasswordAPI,
  deleteNotificationEndPointURL,
  forgotPasswordAPI,
  getAllNotificationEndPointURL,
  getAllScheduleNotificationEndPointURL,
  getAllSentNotificationEndPointURL,
  loginAPI,
  notificationDetailAPI,
  profileAPI,
  profileUpdateAPI,
  sentNotificationEndPointURL,
  signupAPI,
  updateNotificationEndPointURL,
} from "../../routes/apiEndPoints";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { pipSetAccessToken } from "../../utils/pip";

// auth-register
export const authRegister = createAsyncThunk("auth-register", async (props) => {
  const { payload, callback } = props;
  try {
    const response = await API_REQUEST({
      url: signupAPI,
      method: "POST",
      data: payload,
    });
    callback(response);
    return response;
  } catch (error) {
    callback(null, error);
  }
});

// auth-login
export const authLogin = createAsyncThunk("auth-login", async (props) => {
  const { payload, callback } = props;
  try {
    const response = await API_REQUEST({
      url: loginAPI,
      method: "POST",
      data: payload,
      isErrorToast: true,
    });
    pipSetAccessToken(response?.token);
    callback(response);
    return response;
  } catch (error) {
    callback(null, error);
  }
});

// auth-forgot-password
export const authForgotPassword = createAsyncThunk("auth-forgot-password", async (props) => {
  const { payload, callback } = props;
  try {
    const response = await API_REQUEST({
      url: forgotPasswordAPI,
      method: "POST",
      data: payload,
      isErrorToast: true,
    });
    callback(response);
    return response;
  } catch (error) {
    callback(null, error);
  }
}
);

// fetch-profile
export const fetchProfile = createAsyncThunk("fetch-profile", async () => {
  try {
    const response = await API_REQUEST({
      url: profileAPI,
      method: "GET",
    });
    return response;
  } catch (error) { }
});

// auth-change-password
export const changePassword = createAsyncThunk(
  "auth-change-password",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: changePasswordAPI,
        method: "POST",
        data: payload,
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

// update-profile
export const updateProfile = createAsyncThunk(
  "update-profile",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: profileUpdateAPI,
        method: "POST",
        data: payload,
        isErrorToast: true,
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

export const fetchAllSentNotification = createAsyncThunk("fetch-sent-notofication", async () => {
  try {
    const response = await API_REQUEST({
      url: getAllNotificationEndPointURL,
      // url: getAllSentNotificationEndPointURL,
      // url: getAllScheduleNotificationEndPointURL,
      method: "GET",
    });
    return response;
  } catch (error) { }
});

export const CreateSentNotification = createAsyncThunk(
  "create-notofication",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: sentNotificationEndPointURL,
        method: "POST",
        data: payload,
        isErrorToast: true,
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

export const UpdateSentNotification = createAsyncThunk(
  "update-notofication",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: updateNotificationEndPointURL,
        method: "PUT",
        data: payload,
        isErrorToast: true,
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);


export const DeleteSentNotification = createAsyncThunk(
  "delete-notofication",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: deleteNotificationEndPointURL + payload?.id,
        method: "DELETE",
        isErrorToast: true,
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

// fetch-notofication-detail
export const fetchNotificationDetail = createAsyncThunk(
  "fetch-notofication-detail",
  async (props) => {
    const { payload } = props;
    try {
      const response = await API_REQUEST({
        url: notificationDetailAPI,
        method: "POST",
        data: payload,
        isErrorToast: false,
        isSuccessToast: false,
      });
      return response;
    } catch (error) {
    }
  }
);